import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import adminApi, { adminApiClient  } from '../services/adminApi';
interface AdReport {
  id: string;
  adId: string;
  adTitle: string;
  adSlug: string;
  reporterId: string;
  reporterName: string;
  reporterEmail: string;
  reporterPhone?: string;
  reporterJoinDate: string;
  reason: number;
  reasonText: string;
  description?: string;
  reportDate: string;
  status: number;
  statusText: string;
  reviewDate?: string;
  reviewedByName?: string;
  adminNotes?: string;
}

interface ReportFilters {
  status?: number;
  reason?: number;
  page: number;
  pageSize: number;
}

const AdminReportsPage: React.FC = () => {
  const [reports, setReports] = useState<AdReport[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedReport, setSelectedReport] = useState<AdReport | null>(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<AdReport | null>(null);
  const [newStatus, setNewStatus] = useState<number>(1);
  const [adminNotes, setAdminNotes] = useState('');
  const [filters, setFilters] = useState<ReportFilters>({
    page: 1,
    pageSize: 20
  });

  const statusOptions = [
      { value: 1, label: 'Pending Review', color: 'bg-yellow-100 text-yellow-800' },
  { value: 2, label: 'Under Review', color: 'bg-blue-100 text-blue-800' },
  { value: 3, label: 'Resolved', color: 'bg-green-100 text-green-800' },
  { value: 4, label: 'Rejected', color: 'bg-red-100 text-red-800' }
  ];

  const reasonOptions = [
      { value: 1, label: 'Inappropriate or offensive content' },
  { value: 2, label: 'False or misleading information' },
  { value: 3, label: 'Unreasonable price' },
  { value: 4, label: 'Images unrelated to product' },
    { value: 5, label: 'Duplicate ad' },
    { value: 6, label: 'Sale of illegal goods' },
    { value: 7, label: 'Fraud or deception' },
    { value: 8, label: 'Other' }
  ];

  useEffect(() => {
    fetchReports();
  }, [filters]);

  // const fetchReports = async () => {
  //   try {
  //     setLoading(true);
  //     const queryParams = new URLSearchParams();
  //     queryParams.append('page', filters.page.toString());
  //     queryParams.append('pageSize', filters.pageSize.toString());
      
  //     if (filters.status) {
  //       queryParams.append('status', filters.status.toString());
  //     }
  //     if (filters.reason) {
  //       queryParams.append('reason', filters.reason.toString());
  //     }

  //     const response = await fetch(`https://localhost:7000/api/adreport?${queryParams}`, {
  //       method: 'GET',                                         
  //       credentials: 'include',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       setReports(data);
  //     } else {
  //       toast.error('Error loading reports', {
  //         style: {
  //           fontFamily: 'Arial, sans-serif',
  //           textAlign: 'left',
  //           direction: 'ltr'
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     toast.error('Error connecting to server', {
  //       style: {
  //         fontFamily: 'Arial, sans-serif',
  //         textAlign: 'left',
  //         direction: 'ltr'
  //       }
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchReports = async () => {
    try {
      setLoading(true);

      const { page, pageSize, status, reason } = filters;

      const { data } = await adminApiClient.get<AdReport[]>('/admin/adreport', {
        params: {
          page,
          pageSize,
          ...(status ? { status } : {}),
          ...(reason ? { reason } : {}),
        },
        withCredentials: true, // explicit (interceptor also sets this)
      });

      setReports(data);
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || 'Error loading reports';
      toast.error(msg, {
        style: { fontFamily: 'Arial, sans-serif', textAlign: 'left', direction: 'ltr' }
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleStatusUpdate = async () => {
  //   if (!selectedReport) return;

  //   try {
  //     const response = await fetch(`http://localhost:5000/api/adreport/${selectedReport.id}/status`, {
  //       method: 'PUT',
  //       credentials: 'include',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         status: newStatus,
  //         adminNotes: adminNotes
  //       })
  //     });

  //     if (response.ok) {
  //       toast.success('Report status updated successfully', {
  //         style: {
  //           fontFamily: 'Arial, sans-serif',
  //           textAlign: 'left',
  //           direction: 'ltr'
  //         }
  //       });
  //       setShowStatusModal(false);
  //       setSelectedReport(null);
  //       setAdminNotes('');
  //       fetchReports(); // Refresh the list
  //     } else {
  //       const errorText = await response.text();
  //       toast.error(errorText || 'Error updating status', {
  //         style: {
  //           fontFamily: 'Arial, sans-serif',
  //           textAlign: 'left',
  //           direction: 'ltr'
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     toast.error('Error connecting to server', {
  //       style: {
  //         fontFamily: 'Arial, sans-serif',
  //         textAlign: 'left',
  //         direction: 'ltr'
  //       }
  //     });
  //   }
  // };

  const handleStatusUpdate = async () => {
    if (!selectedReport) return;

    try {
      await adminApiClient.put(
        `/admin/adreport/${selectedReport.id}/status`,
        { status: newStatus, adminNotes },
        { withCredentials: true }
      );

      toast.success('Report status updated successfully', {
        style: { fontFamily: 'Arial, sans-serif', textAlign: 'left', direction: 'ltr' }
      });

      setShowStatusModal(false);
      setSelectedReport(null);
      setAdminNotes('');
      fetchReports(); // Refresh the list
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || 'Error updating status';
      toast.error(msg, {
        style: { fontFamily: 'Arial, sans-serif', textAlign: 'left', direction: 'ltr' }
      });
    }
  };

  const openStatusModal = (report: AdReport) => {
    setSelectedReport(report);
    setNewStatus(report.status);
    setAdminNotes(report.adminNotes || '');
    setShowStatusModal(true);
  };

  const openUserModal = (report: AdReport) => {
    setSelectedUser(report);
    setShowUserModal(true);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status: number, statusText: string) => {
    const statusOption = statusOptions.find(opt => opt.value === status);
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusOption?.color || 'bg-gray-100 text-gray-800'}`}>
        {statusText}
      </span>
    );
  };

  const getPriorityColor = (reason: number) => {
    // Higher priority for fraud, illegal goods, inappropriate content
    if ([1, 6, 7].includes(reason)) return 'border-l-red-500 bg-red-50';
    if ([2, 4, 5].includes(reason)) return 'border-l-yellow-500 bg-yellow-50';
    return 'border-l-gray-500 bg-gray-50';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" dir="ltr">
      {/* Header */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Ad Reports Management</h1>
            <p className="text-gray-600 mt-1">Review and manage user reports</p>
          </div>
          <div className="flex items-center gap-4">
            <div className="bg-gradient-to-r from-red-500 to-pink-600 text-white px-4 py-2 rounded-lg">
              🚨 {reports.filter(r => r.status === 1).length} Pending Review
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
            <select
              value={filters.status || ''}
              onChange={(e) => setFilters({...filters, status: e.target.value ? parseInt(e.target.value) : undefined, page: 1})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option value="">All Statuses</option>
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Report Reason</label>
            <select
              value={filters.reason || ''}
              onChange={(e) => setFilters({...filters, reason: e.target.value ? parseInt(e.target.value) : undefined, page: 1})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option value="">All Reasons</option>
              {reasonOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Items per Page</label>
            <select
              value={filters.pageSize}
              onChange={(e) => setFilters({...filters, pageSize: parseInt(e.target.value), page: 1})}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>

          <div className="flex items-end">
            <button
              onClick={() => setFilters({ page: 1, pageSize: 20 })}
              className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            >
              Clear Filters
            </button>
          </div>
        </div>
      </div>

      {/* Reports List */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {reports.length === 0 ? (
          <div className="p-12 text-center">
            <div className="text-4xl mb-4">📝</div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No reports found</h3>
            <p className="text-gray-500">No reports match the selected filters</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {reports.map((report) => (
              <div
                key={report.id}
                className={`p-6 border-l-4 hover:bg-gray-50 transition-colors ${getPriorityColor(report.reason)}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1 space-y-3">
                    {/* Header */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <h3 className="text-lg font-semibold text-gray-900">
                          {report.adTitle}
                        </h3>
                        {getStatusBadge(report.status, report.statusText)}
                      </div>
                      <button
                        onClick={() => openStatusModal(report)}
                        className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors text-sm"
                      >
                        Manage Report
                      </button>
                    </div>

                    {/* Report Details */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Report Reason:</span> {report.reasonText}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Reporter:</span> {report.reporterName}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Report Date:</span> {formatDate(report.reportDate)}
                        </p>
                      </div>
                      <div>
                        {report.reviewDate && (
                          <p className="text-sm text-gray-600">
                            <span className="font-medium">Review Date:</span> {formatDate(report.reviewDate)}
                          </p>
                        )}
                        {report.reviewedByName && (
                          <p className="text-sm text-gray-600">
                            <span className="font-medium">Reviewed By:</span> {report.reviewedByName}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Description */}
                    {report.description && (
                      <div className="bg-gray-100 rounded-lg p-3">
                        <p className="text-sm text-gray-700">
                          <span className="font-medium">Description:</span> {report.description}
                        </p>
                      </div>
                    )}

                    {/* Admin Notes */}
                    {report.adminNotes && (
                      <div className="bg-blue-50 rounded-lg p-3">
                        <p className="text-sm text-blue-700">
                          <span className="font-medium">Admin Notes:</span> {report.adminNotes}
                        </p>
                      </div>
                    )}

                    {/* Quick Actions */}
                    <div className="flex items-center gap-2 pt-2">
                      <a
                        href={`/ads/${report.adSlug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-600 hover:text-primary-800 text-sm font-medium"
                      >
                        View Ad
                      </a>
                      <span className="text-gray-300">|</span>
                      <button
                        onClick={() => openUserModal(report)}
                        className="text-primary-600 hover:text-primary-800 text-sm font-medium"
                      >
                        View Reporter Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-600">
            Showing {((filters.page - 1) * filters.pageSize) + 1} to {Math.min(filters.page * filters.pageSize, reports.length)} of {reports.length} reports
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setFilters({...filters, page: Math.max(1, filters.page - 1)})}
              disabled={filters.page === 1}
              className="px-3 py-1 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
            >
              Previous
            </button>
            <span className="px-3 py-1 bg-primary-100 text-primary-800 rounded-lg font-medium">
              {filters.page}
            </span>
            <button
              onClick={() => setFilters({...filters, page: filters.page + 1})}
              disabled={reports.length < filters.pageSize}
              className="px-3 py-1 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Status Update Modal */}
      {showStatusModal && selectedReport && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-96 overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Manage Report: {selectedReport.adTitle}
                </h3>
                <button
                  onClick={() => setShowStatusModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    New Status
                  </label>
                  <select
                    value={newStatus}
                    onChange={(e) => setNewStatus(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  >
                    {statusOptions.map(option => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Admin Notes (Optional)
                  </label>
                  <textarea
                    value={adminNotes}
                    onChange={(e) => setAdminNotes(e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Additional notes or comments..."
                  />
                </div>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-medium text-gray-900 mb-2">Report Details:</h4>
                  <p className="text-sm text-gray-600 mb-1">
                    <span className="font-medium">Reason:</span> {selectedReport.reasonText}
                  </p>
                  <p className="text-sm text-gray-600 mb-1">
                    <span className="font-medium">Reporter:</span> {selectedReport.reporterName}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Date:</span> {formatDate(selectedReport.reportDate)}
                  </p>
                  {selectedReport.description && (
                    <p className="text-sm text-gray-600 mt-2">
                      <span className="font-medium">Description:</span> {selectedReport.description}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex items-center justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowStatusModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleStatusUpdate}
                  className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
                >
                  Update Status
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* User Profile Modal */}
      {showUserModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Reporter Information
                </h3>
                <button
                  onClick={() => setShowUserModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                    <span className="text-primary-600 font-semibold text-lg">
                      {selectedUser.reporterName.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">{selectedUser.reporterName}</h4>
                    <p className="text-sm text-gray-600">{selectedUser.reporterEmail}</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-sm font-medium text-gray-700">Full Name:</span>
                    <span className="text-sm text-gray-900">{selectedUser.reporterName}</span>
                  </div>
                  
                  <div className="flex justify-between">
                    <span className="text-sm font-medium text-gray-700">Email:</span>
                    <span className="text-sm text-gray-900">{selectedUser.reporterEmail}</span>
                  </div>
                  
                  {selectedUser.reporterPhone && (
                    <div className="flex justify-between">
                      <span className="text-sm font-medium text-gray-700">Phone Number:</span>
                      <span className="text-sm text-gray-900">{selectedUser.reporterPhone}</span>
                    </div>
                  )}
                  
                  <div className="flex justify-between">
                    <span className="text-sm font-medium text-gray-700">Join Date:</span>
                    <span className="text-sm text-gray-900">{formatDate(selectedUser.reporterJoinDate)}</span>
                  </div>
                </div>

                <div className="pt-4 border-t border-gray-200">
                  <div className="bg-blue-50 rounded-lg p-3">
                    <h5 className="font-medium text-blue-900 mb-1">Current Report:</h5>
                    <p className="text-sm text-blue-700">
                      <span className="font-medium">Ad:</span> {selectedUser.adTitle}
                    </p>
                    <p className="text-sm text-blue-700">
                      <span className="font-medium">Reason:</span> {selectedUser.reasonText}
                    </p>
                    <p className="text-sm text-blue-700">
                      <span className="font-medium">Report Date:</span> {formatDate(selectedUser.reportDate)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowUserModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminReportsPage; 